module.exports = __webpack_public_path__ + "img/r3.51d67b98.jpg";